export const kpiFiguresEndpoint = (userId: string) => `users/${userId}/kpi-figures`;
